import axios from './request'
import config from './config'
const api = {
  // 获取快递柜信息
  getCabList: data => {
    return axios({
      baseURL: config.NANXUN_HOST,
      url: '/kuaidiguiGuiji/KuaidiguiGuijiByName',
      method: 'post',
      data
    })
  },
  // 品牌入库图表
  getRKChartByCompany: data => {
    return axios({
      baseURL: config.NANXUN_HOST,
      url: '/kuaidiguiGuiji/selectPinpaiRukuCount',
      method: 'post',
      data
    })
  },
  // 品牌出库图表
  getCKChartByCompany: data => {
    return axios({
      baseURL: config.NANXUN_HOST,
      url: '/kuaidiguiGuiji/selectPinpaiQianshouCount',
      method: 'post',
      data
    })
  },
  // 柜机入库图表
  getRKChartByCabinet: data => {
    return axios({
      baseURL: config.NANXUN_HOST,
      url: '/kuaidiguiGuiji/selectGuijiRukuCount',
      method: 'post',
      data
    })
  },
  // 柜机出库图表
  getCKChartByCabinet: data => {
    return axios({
      baseURL: config.NANXUN_HOST,
      url: '/kuaidiguiGuiji/selectGuijiQianshouCount',
      method: 'post',
      data
    })
  },
  // 入库/签收量总计
  getExpressNumsTotal: data => {
    return axios({
      baseURL: config.NANXUN_HOST,
      url: '/kuaidiguiGuiji/selectAllCount',
      method: 'post',
      data
    })
  }
}

export default api
